import React from "react";

function MissionSubCard({ children }) {
    return (
        <div className="mission-sub-card">
            {children}
        </div>
    )
}

function MissionScreenerSubCard({ children }) {
    return (
        <div className="mission-sub-card mission-screener-sub-card">
            {children}
        </div>
    )
}

function MissionSubCardHorizontalDivider({ showMobile = false, showDesktop = true }) {
    return (
        <div className={`mission-sub-card-horizontal-divider ${showMobile ? "show-mobile" : ""} ${!showDesktop ? "hide-desktop" : ""}`} />
    )
}

export { MissionSubCard, MissionSubCardHorizontalDivider, MissionScreenerSubCard };